var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    stroke: "#B1B1B1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.798 6.684V4.976H10.758V6.684H8.798ZM8.91 15V8.154H10.66V15H8.91Z",
    fill: "#B1B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfos);
export default __webpack_public_path__ + "static/media/infos.a79bfc23eebb8955ca777b7528d1506f.svg";
export { ForwardRef as ReactComponent };